<template>
  <div class="profile-publication-agreement">
    <Checkbox class="profile-publication-agreement__checkbox" :value="value" :error="error" @input="onInput">
      <template #label>
        {{ $root.staticText.forms.agreePostPhoto }}
      </template>
    </Checkbox>
  </div>
</template>

<script>
import Checkbox from '@shared/ui/public/forms/fields/Checkbox.vue'

export default {
  name: 'ProfilePublicationAgreement',
  emits: ['input'],
  components: { Checkbox },
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.profile-publication-agreement
  &__checkbox
    font-size: 16px
    width: fit-content
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/ProfilePublicationAgreement.vue